import React from "react";
import Entities from "../../components/Entities";
import { getHotSheets } from "../../API";

export async function loader() {
  return getHotSheets();
}

function HotSheets() {
  return (
    <Entities
      shema={{
        searchFromServer: false,
        fields: [
          { name: "Name", propertyName: "name", search: true },
          { name: "Month", propertyName: "month" },
          { name: "Manufacturer", propertyName: "manufacturer", isObject: true },
        ],
      }}
    />
  );
}

export default HotSheets;
